import { render, staticRenderFns } from "./GroupCredit.vue?vue&type=template&id=b4647304"
import script from "./GroupCredit.vue?vue&type=script&lang=js"
export * from "./GroupCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports